<script setup lang="ts">
  import { Icon, IconName } from '@travelata-libs/ui-kit';
  type IconType = 'orders' | 'tourhunter' | 'settings' | 'logout';
  interface AccountMenuIconProps {
    name: `${IconType}`;
  }

  defineProps<AccountMenuIconProps>();
  const icons: Record<IconType, IconName> = {
    logout: IconName.Logout,
    orders: IconName.Beach,
    tourhunter: IconName.Heart,
    settings: IconName.Filters,
  };
</script>

<template>
  <Icon
    :class="[
      'account-menu-icon__icon',
      {
        'account-menu-icon__logout': name === 'logout',
      },
    ]"
    :name="icons[name]"
    size="l"
  ></Icon>
</template>

<style scoped lang="scss">
  .account-menu-icon {
    &__icon {
      fill: var(--color-text-primary);
    }

    &__logout {
      fill: var(--color-rose-60);
    }
  }
</style>
